import { Spin } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { FormValidationProvider } from 'hooks';
import { BtlBaseForm } from 'pages/BtlApplicationFormPage/BtlBaseForm';
import { useNavigate } from 'react-router-dom';
import { OoCaseFormFooter } from '../OoCaseFormFooter';
import { isOoFinancingFormEditable, useOoCaseFinancingForm } from './useOoCaseFinancingForm';

interface CaseFinancingPageProps {
  caseId: string;
  case?: BtlApplication;
  isCaseLoading: boolean;
  sidebarContext: OoCaseSidebarContext;
  canAccessHppPages: boolean;
}

function CaseFinancingPageContent({
  caseId,
  case: caseData,
  isCaseLoading,
  sidebarContext,
  canAccessHppPages,
}: CaseFinancingPageProps) {
  const navigate = useNavigate();
  const form = useOoCaseFinancingForm({
    caseId,
    caseData,
    isCaseLoading,
    sidebarContext,
    canAccessHppPages,
  });

  const handleNavigate = (itemId: CaseSidebarItemId) => {
    navigate({ search: `?section=${itemId}` });
  };

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return (
    <BtlBaseForm
      {...form.formProps}
      submitter={
        form.isFormEditable
          ? {
              render: ({ form: antForm }) => (
                <OoCaseFormFooter {...form.footerProps} form={antForm} isFormEditable onNavigate={handleNavigate} />
              ),
            }
          : false
      }
    />
  );
}

export function CaseFinancingPage(props: CaseFinancingPageProps) {
  if (
    !isOoFinancingFormEditable(props.case, props.canAccessHppPages, props.sidebarContext.canEditDipAcceptedSections)
  ) {
    return <CaseFinancingPageContent {...props} />;
  }

  return (
    <FormValidationProvider>
      <CaseFinancingPageContent {...props} />
    </FormValidationProvider>
  );
}

export { isOoFinancingFormEditable };
